import React, { useCallback, useEffect, useRef, useState } from "react";
import SearchBar from "../components/SearchBar";
import {
  Container,
  ClausuleItemContainer,
  ClausuleItem,
  ClausuleLabel,
  FeaturesClauseContainer,
  FlexPagination,
  WrapperAll,
  TextEmpy
} from "./styles";

import api from "../../../services/api";
import ButtonIcons from "../../../shared/components/ButtonIcons";
import EditClausesIcon from "../../editor/assets/icons/EditClausesIcon";
import RemoveClausesIcon from "../../editor/assets/icons/RemoveClausesIcon";
import PuffLoader from "react-spinners/PuffLoader";
import Pagination from "../../../shared/components/Pagination";
import IconSvg from "../../editor/components/IconSvg";
import iconDownload from "../../../shared/assets/download-icon.svg";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DownloadDocument from "../../../shared/components/DownloadDocument";
import { PagesProps } from "../../../dtos/PagesProps";
import { LoadingFlex } from "../../login/pages/Login/styles";
import { useMainHook } from "../../../hooks/main";
import { ContractAnimation } from "../../../shared/components/ContractAnimation";
import PreviewDocument from "../../../shared/components/PreviewDocument";

interface IShowAutomatizedDocumentAPI {
  automation_user_template_id: string;
  created_at: string;
  description: null | string;
  download_counter: number;
  id: string;
  is_automation: boolean;
  save_counter: number;
  template: { arrayOfPages: PagesProps[] };
  thumbnail: string;
  thumbnail_url: string;
  title: string;
  updated_at: string;
  user_id: string;
}

interface MyAutomationsProps {
  id: string;
  user_id: string;
  title: string;
  description?: string;
  thumbnail: string;
  is_automation: boolean;
  automation_user_template_id: string;
  created_at: string;
  updated_at: string;
  thumbnail_url: string;
}

interface ParamsProps {
  search?: string;
  pagination?: number;
}

const MyAutomations: React.FC = () => {
  const [automations, setAutomations] = useState<MyAutomationsProps[]>([]);
  const [refresh, setRefresh] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [pagesDownload, setPagesDownload] = useState<PagesProps[]>([]);
  const [nameDocument, setNameDocument] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingViewAutomation, setLoadingViewAutomation] = useState(false);
  const { setObjectScreen, objectScreen } = useMainHook();

  const [visibilityFeatures, setVisibilityFeatures] = useState({
    visible: false,
    index: 0
  });
  const [params, setParams] = useState<ParamsProps>({
    search: "",
    pagination: 0
  });

  const navigate = useNavigate();

  const handleVisibilityActive = useCallback(
    (visible: boolean, index: number) => {
      setVisibilityFeatures({
        visible,
        index
      });
    },
    []
  );

  useEffect(() => {
    const autoLoadAutomations = async () => {
      try {
        const responseAutomations = await api.get(
          "user-templates/list-automation-user-template-dashboard",
          {
            params: {
              search: params.search ? params.search : null,
              pagination: params.pagination
            }
          }
        );
        setAutomations(responseAutomations.data.dataArray);
        setTotalPages(responseAutomations.data.pagination);
        setLoading(false);
      } catch (err) {
        console.log(err, "error when get automations");
        setLoading(false);
      }
    };

    autoLoadAutomations();
  }, [refresh, params]);

  const handleDeleteAutomation = useCallback(async (id: string) => {
    try {
      const responseDelete = await api.delete(`user-templates/${id}`);
      setRefresh(prevState => !prevState);
      toast.success("Automacao excluida com sucesso.");
    } catch (err) {
      console.log(err, "error when delete automation");
      toast.error("Algo deu errado!");
    }
  }, []);

  const handleEditAutomation = useCallback(
    async (id: string) => {
      try {
        const responseTemplate = await api.get(`user-templates/${id}`);
        setObjectScreen(responseTemplate.data.template.arrayOfPages);
      } catch (err) {
        console.log("error when get specific template for load state ");
      }

      navigate(`editor/my-template/${id}`);
    },
    [objectScreen]
  );

  const handleDownloadAutomation = useCallback(
    async (id: string, index: number) => {
      const toastId = toast.loading("Preparando seu download...", {
        closeOnClick: true,
        autoClose: 5000
      });
      try {
        const responseTemplate = await api.get(`user-templates/${id}`);
        setPagesDownload(responseTemplate.data.template.arrayOfPages);
        setNameDocument(state => (state = responseTemplate.data.title));
        setIsDownloading(true);
        setTimeout(() => {
          toast.update(toastId, {
            render: "Seu documento ficou pronto e será baixado.",
            type: "success",
            isLoading: false,
            closeOnClick: true,
            autoClose: 3000
          });
        }, 1800);
      } catch (err) {
        console.log(err, "error when fetch specific template");
        toast.update(toastId, {
          render: "Algo deu errado! Tente novamente mais tarde",
          type: "error",
          isLoading: false,
          closeOnClick: true,
          autoClose: 3000
        });
      }
    },
    [pagesDownload, nameDocument]
  );

  const handleSearchButton = useCallback(() => {
    setParams(state => {
      return {
        ...state,
        search: search
      };
    });
  }, [search, params]);

  const idCurrentAutomatizedDocument = useRef<string | null>(null);
  const [modalPreviewDocumentVisiblle, setModalPreviewDocumentVisible] =
    useState(false);
  const documentAutomatized = useRef(null);
  const documentPreviewData = useRef<PagesProps[] | null>(null);
  const [indexLoading, setIndexLoading] = useState(0);

  const handlePreviewDocumentAutomation = useCallback(
    async (document_id: string, index: number) => {
      try {
        setLoadingViewAutomation(true);
        setIndexLoading(index);
        idCurrentAutomatizedDocument.current = document_id;
        const fetchDocumentPreview = await api.get(
          `user-templates/${document_id}`
        );
        const { template } =
          fetchDocumentPreview.data as IShowAutomatizedDocumentAPI;
        documentPreviewData.current = template.arrayOfPages;
        setModalPreviewDocumentVisible(true);
        setLoadingViewAutomation(false);
      } catch (error) {
        console.log("error getting document to preview");
      }
    },
    []
  );

  const handleCloseModal = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget) {
        setModalPreviewDocumentVisible(false);
      }
    },
    []
  );

  return (
    <WrapperAll>
      {loading ? (
        <LoadingFlex>
          {/* <LoadingEditor /> */}
          <ContractAnimation />
        </LoadingFlex>
      ) : (
        <>
          <ToastContainer />
          <DownloadDocument
            downloading={isDownloading}
            setDownloading={setIsDownloading}
            documentName={nameDocument}
            pagesToBeRendered={pagesDownload}
          />

          <PreviewDocument
            open={modalPreviewDocumentVisiblle}
            handleCloseModal={handleCloseModal}
            pagesToBeRendered={documentPreviewData.current}
          />
          <Container>
            <span className="heading">Versões automatizadas</span>
            <SearchBar
              value={search}
              onChange={e => setSearch(e.target.value)}
              label={"Pesquisar"}
              onClickSearchButton={handleSearchButton}
            />
            <ClausuleItemContainer>
              {automations.length > 0 ? (
                automations.map((item, index) => {
                  return (
                    <ClausuleItem
                      onMouseEnter={() => handleVisibilityActive(true, index)}
                      onMouseLeave={() => handleVisibilityActive(false, index)}
                      // onClick={() => handleEditAutomation(item.id)}
                    >
                      <ClausuleLabel
                        onClick={() =>
                          handlePreviewDocumentAutomation(item.id, index)
                        }
                      >
                        {loadingViewAutomation && index === indexLoading ? (
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                          >
                            <PuffLoader color="#663399" size="28" />
                          </div>
                        ) : (
                          `${item.title}`
                        )}
                      </ClausuleLabel>

                      {visibilityFeatures.visible &&
                        visibilityFeatures.index === index && (
                          <FeaturesClauseContainer>
                            <ButtonIcons
                              onClick={() =>
                                handleDownloadAutomation(item.id, index)
                              }
                              width="30px"
                            >
                              <IconSvg
                                className="download-icon"
                                description=""
                                src={iconDownload}
                              />
                            </ButtonIcons>
                            <ButtonIcons
                              onClick={() => handleEditAutomation(item.id)}
                              margin="0 0 0 10px"
                              width="30px"
                            >
                              <EditClausesIcon />
                            </ButtonIcons>
                            <ButtonIcons
                              onClick={() => {
                                handleDeleteAutomation(item.id);
                              }}
                              margin="0 0 0 10px"
                              width="30px"
                            >
                              <RemoveClausesIcon />
                            </ButtonIcons>
                          </FeaturesClauseContainer>
                        )}
                    </ClausuleItem>
                  );
                })
              ) : (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center"
                  }}
                >
                  <TextEmpy>Nenhuma automação encontrada.</TextEmpy>
                </div>
              )}
            </ClausuleItemContainer>
            <div style={{ width: "100%", height: "100px" }}></div>
          </Container>
        </>
      )}

      {!loading && automations.length > 0 && (
        <FlexPagination>
          <Pagination
            total={totalPages}
            offset={params.pagination}
            setDataParams={setParams}
            dataParams={params}
          />
        </FlexPagination>
      )}
    </WrapperAll>
  );
};

export default MyAutomations;
